import { Fragment } from "react";

export default function PreviewPDF(props) {

  return (
    <Fragment>
        <div
          style={{
            width: "90%",
            height: "90%",
            margin: "auto",
            marginTop: "1rem",
            paddingTop: "1rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <iframe
            title="PDF Viewer"
            id="pdf_iframe"
            src={props.fileUrl}
            width="90%"
            height="800px"
          ></iframe>
        </div>
    </Fragment>
  );
}
